var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "linked_block" },
    [
      _c("b-table", {
        staticClass: "table-responsive-lg",
        attrs: {
          "thead-class": "bg-primary text-white",
          striped: "",
          items: _vm.files,
          fields: _vm.fields,
        },
        scopedSlots: _vm._u([
          {
            key: "head(infoblock)",
            fn: function (data) {
              return [
                _c("span", {
                  staticClass: "text-center",
                  domProps: { innerHTML: _vm._s(data.label) },
                }),
              ]
            },
          },
          {
            key: "cell(infoblock)",
            fn: function (data) {
              return [
                _c("i", {
                  staticClass: "fas fa-indent show_inside-",
                  on: { click: data.toggleDetails },
                }),
              ]
            },
          },
          {
            key: "cell(quest_name)",
            fn: function (data) {
              return [
                _c("a", { attrs: { href: data.item.link, target: "_blank" } }, [
                  _vm._v(_vm._s(data.value)),
                ]),
              ]
            },
          },
          {
            key: "row-details",
            fn: function (row) {
              return [
                _c(
                  "b-card",
                  [
                    _c(
                      "b-row",
                      { staticClass: "mb-2" },
                      [
                        _c(
                          "b-col",
                          { staticClass: "text-sm-left", attrs: { sm: "2" } },
                          [
                            _vm._v(
                              "\n                        Преамбула\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("b-col", {
                          domProps: {
                            innerHTML: _vm._s(row.item.obj.pre_text),
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "mb-2" },
                      [
                        _c(
                          "b-col",
                          { staticClass: "text-sm-left", attrs: { sm: "2" } },
                          [
                            _vm._v(
                              "\n                        Проблема\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("b-col", {
                          domProps: { innerHTML: _vm._s(row.item.obj.problem) },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "mb-2" },
                      [
                        _c(
                          "b-col",
                          { staticClass: "text-sm-left", attrs: { sm: "2" } },
                          [
                            _vm._v(
                              "\n                        Запропоноване рішення\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("b-col", {
                          domProps: { innerHTML: _vm._s(row.item.obj.result) },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }